import { useSyncExternalStore } from 'react';

const subscribe = () => () => {};
const getSnapshot = () => false;
const getServerSnapshot = () => true;

/**
 * True on the server and through React's hydration pass, false for every client-only render. Gate
 * browser-only values (localStorage, media queries) on this to render something the server can
 * produce too, then reconcile to the real value in the re-render React schedules once hydration
 * commits.
 *
 * `useSyncExternalStore`'s server snapshot is used *only* on the server and during hydration, so a
 * tree that first mounts in a client-only render — anything behind a loading gate that resolves after
 * hydration, for example —
 * reads `false` on its very first render and behaves exactly as it did before.
 */
export function useIsHydrating(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
